import en from '../i18n/en-GB';
import { Language } from '../types/Language';

export type TranslationKey = keyof typeof en;

export const translations = {
  en,
};

export const localeMap = {
  'en-gb': 'en',
  'en-us': 'en',
};

export const languageList: Array<{ name: string; language: Language }> = [
  {
    name: 'english',
    language: 'en',
  },
];

const validLanguages = ['en'];
export const isValidLanguage = (language: string): language is Language => validLanguages.includes(language);

export default translations;
